import React, { createRef } from "react"
//import * as config from "../../framework/config"
import services from "../../api/services"
import { getSessionToken } from "../../api/session";
import { Screen } from "../components/layout"
import Secure from "../components/secure"

export class Slideshow extends Screen {

    constructor(props) {
        super(props);

        this.state = {images: null};
        this.root = createRef();
        this.loadingPool = [];
        this.loading = false;
    }

    addToLoadingPool(img) {
        if (!this.loadingPool.some(p => p === img)) {
            this.loadingPool.push(img);
        }

        this.load();
    }

    load() {
        if (this.loading) {
            return;
        }

        this.loading = true;

        const next = () => {
            if (this.loadingPool.length > 0) {
                const img = this.loadingPool.shift();

                if ($(img).attr("data-src")) {
                    $(img).attr("src", $(img).attr("data-src"));
                    $(img).attr("data-src", null);

                    console.log("loading", $(img).attr("src"));
                }

                setTimeout(next, 250);
            } else {
                this.loading = false;
            }
        }

        next();
    }

    componentDidMount() {
        services.get("public/surveys/" + this.props.survey + "/categories/" + this.props.category + "/slideshow")
            .then(r => this.setState({images: r.value}, () => {
                this.loadingPool = [];
                this._onScroll();
            }))
            .catch(r => console.error(r));

        $(window).on("resize", this._onResize = () => {
            $(this.root?.current).height($(window).height() - 8);
        });

        this._onResize();
        setTimeout(() => this._onResize(), 250);


        $(this.root.current).on("scroll", this._onScroll = () => {
            const scrollY = $(this.root.current).scrollTop();
            const height = $(window).height();

            $(this.root.current).find("img").each((index, img) => {
                const y = $(img).offset().top;
                if (y < scrollY + height) {
                    if ($(img).attr("data-src")) {
                        this.addToLoadingPool(img);
                    }
                }
            })            
        });

    }

    componentWillUnmount() {
        $("window").off("resize", this._onResize);
    }

    render() {
        return <Secure permissions={["photos:show"]}>
        
            <div className="slideshow-container" ref={this.root}>
               
                {this.state.images?.map(image => 
                    <a key={image.original} href={image.original + "&__TOKEN=" + encodeURIComponent(getSessionToken())} target="_blank">
                        <img alt="image" data-src={image.thumbnail + "&__TOKEN=" + encodeURIComponent(getSessionToken())} width="150" height="100" />
                    </a>
                )}

                {this.state.images?.length == 0 && <div className="info">Nessuna foto nella categoria</div> }
                {this.state.images == null && <div className="info">Caricamento in corso</div> }

            </div>
        </Secure>
    }

}